import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { FeatureFlagGate } from '@internal/plugin-feature-flags-common/components';
import { ADR_FEATURE_FLAG } from '@internal/plugin-feature-flags-common';
import { adrApiRef, AdrClient } from './api';

// adrRouteRef: native RouteRef for the ADR entity content tab.
// Bound to a path by EntityContentBlueprint in entityContentExtensionsModule.
export const adrRouteRef = createRouteRef();

/** Route ref for the platform-wide ADR browse page at `/adr`. */
export const adrBrowseRouteRef = createRouteRef();

const adrApi = ApiBlueprint.make({
  name: 'adr',
  params: define =>
    define(
      createApiFactory({
        api: adrApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new AdrClient({ discoveryApi, fetchApi }),
      }),
    ),
});

const adrBrowsePage = PageBlueprint.make({
  name: 'browse',
  params: {
    path: '/adr',
    noHeader: true,
    routeRef: adrBrowseRouteRef,
    // Intentional: platform browse stays admins_only until rollout is complete.
    // Entity ADR tabs are registered separately and are not gated.
    loader: () =>
      import('./components/AdrBrowsePage').then(m => (
        <FeatureFlagGate flag={ADR_FEATURE_FLAG}>
          <m.AdrBrowsePage />
        </FeatureFlagGate>
      )),
  },
});

const adrReadPage = PageBlueprint.make({
  name: 'read',
  params: {
    path: '/adr/read',
    noHeader: true,
    loader: () =>
      import('./components/AdrBrowsePage').then(m => (
        <FeatureFlagGate flag={ADR_FEATURE_FLAG}>
          <m.AdrReadPage />
        </FeatureFlagGate>
      )),
  },
});

const adrBrowseAliasPage = PageBlueprint.make({
  name: 'browse-alias',
  params: {
    path: '/adrs',
    noHeader: true,
    loader: () =>
      import('./components/AdrBrowsePage').then(m => (
        <FeatureFlagGate flag={ADR_FEATURE_FLAG}>
          <m.AdrBrowseAliasRedirect />
        </FeatureFlagGate>
      )),
  },
});

// The ADRs entity content tab is registered in entityContentExtensionsModule
// (packages/app/src/modules/entityContentExtensionsModule.tsx) so it can be
// placed in the correct tab order alongside all other entity content blueprints.
export default createFrontendPlugin({
  pluginId: 'adr',
  extensions: [adrApi, adrBrowsePage, adrReadPage, adrBrowseAliasPage],
  routes: {
    browse: adrBrowseRouteRef,
  },
});
